import axios from "axios"
// 引入vuex，用来读取token
import store from "@/store"

// 创建axios实例
const service = axios.create({
    baseURL: "/api",   // 后端接口统一基础地址，vue代理会转发这个
    timeout: 120000   // 请求超时时间 2分钟，大模型回复慢，时间设置长一点
})

// ==========请求拦截器：每一次发请求之前自动执行==========
service.interceptors.request.use(config => {
    // 优先取vuex的token，没有就读localStorage，兼容模拟阶段
    let token = store.state.user?.token || localStorage.getItem('token')
    if (token) {
        // ✅修复：Bearer后面必须带空格！！
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}, error => {
    return Promise.reject(error)
})

// ==========响应拦截器：后端返回数据之后自动执行==========
service.interceptors.response.use(
    response => {
        // 直接把后端返回的data吐出来，页面不需要写response.data
        return response.data
    },
    error => {
        console.error("接口错误：", error)
        // 401未登录，清除token跳登录页
        if(error.response && error.response.status === 401){
            localStorage.removeItem('token')
            store.commit("user/clearToken")
            // 需要在本文件导入router，取消下面注释
            // import router from '@/router'
            // router.push('/login')
        }
        return Promise.reject(error)
    }
)

export default service